import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { ResetStyle, CssClasses, ThemeDefault } from '@paygreen/paygreen-ui';

/**
 * Style global of the iframe which display component
 */
export const GlobalStyle = createGlobalStyle`
    ${normalize};
    ${ResetStyle};
    ${CssClasses};

    html {
        scroll-behavior: smooth;
    }

    body {
        font-size: ${ThemeDefault.font.size.base};
    }
`;
